export default "__VITE_PUBLIC_ASSET__651d62b3__"